import { el } from "@dhx/ts-common/dom";

export function customHTMLButton(item: any, widgetName?: string, asMenuItem?: boolean) {
	const getAriaAttrs = item => {
		const attrs = {
			"aria-disabled": item.disabled ? "true" : "false",
		};

		if (item.twoState || item.active || item.$activeParent) {
			attrs["aria-pressed"] = item.active || item.$activeParent ? "true" : "false";
		}

		return attrs;
	};
	const baseClass = asMenuItem ? " dhx_button dhx_menu-button" : " dhx_button dhx_nav-menu-button";
	return el(
		"button",
		{
			class: "dhx_custom-button" + baseClass + (item.$activeParent ? baseClass + "--active" : ""),
			"data-dhx-id": item.id,
			type: "button",
			".innerHTML": item.html,
			...getAriaAttrs(item),
		},
		item.html ? "" : item.value
	);
}
